import script from "./DocMegastoreView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocMegastoreView.vue?vue&type=script&setup=true&lang=js"

import "./DocMegastoreView.vue?vue&type=style&index=0&id=81affcf2&lang=scss"

const __exports__ = script;

export default __exports__